import assign from 'lodash/assign';
import groupBy from 'lodash/groupBy';
import reduce from 'lodash/reduce';
import template from './dataModificationLock.html';

class DataModificationLockComponent {
  /** @ngInject */
  constructor($log, DataModificationLockService) {
    this.$log = $log;
    this.DataModificationLockService = DataModificationLockService;

    this.lock = {};
  }

  $onInit() {
    this.DataModificationLockService
      .get()
      .then(result => assign(this.lock, result, this.transformData(result)));
  }

  transformData(data) {
    const blockedResources = groupBy(data.blockedResources, i => i.categoryResources);
    const blockedResourcesObj = reduce(blockedResources, (result, value, key) => {
      result[key] = reduce(value, (result, value) => {
        result[value.blockedAction] = true;
        return assign({
          CREATE: false,
          UPDATE: false,
          DELETE: false
        }, result);
      }, {});
      return result;
    }, {});
    return assign({}, blockedResourcesObj);
  }
}

export const DataModification = {
  template,
  controller: DataModificationLockComponent
};
